import { FC } from "react"
import cx from "classnames"
import type { CampaignStatus, PlacementState } from "@/types/entities/campaign"

type Props = {
  className?: string
  placementState?: PlacementState | null
  status?: CampaignStatus | string | null
}

export const placementStateColorMap: Record<PlacementState, string> = {
  Building: "border-outline bg-input text-black-secondary",
  Ready: "border-positive/30 bg-positive/10 text-positive",
  Optimizing: "border-warning/40 bg-warning/20 text-black",
  "Action Required": "border-error/30 bg-error/10 text-error",
}

const placementStates = Object.keys(placementStateColorMap) as PlacementState[]

const CampaignPlacementStatePill: FC<Props> = ({
  className,
  placementState,
  status,
}: Props) => {
  if (status !== "active") {
    return null
  }

  const value =
    placementState && placementStates.includes(placementState)
      ? placementState
      : "Building"

  return (
    <span
      className={cx(
        "inline-flex w-fit items-center whitespace-nowrap rounded-full border px-2 py-0.5 text-xs font-medium leading-4",
        placementStateColorMap[value],
        className,
      )}
    >
      {value}
    </span>
  )
}

export default CampaignPlacementStatePill
